import React, { useState } from "react";
import { Button, Paper, Box } from "@mui/material";
import { NormalText } from "../../../components/TextParts";
import { text1, text2, text3 } from "../TextSample";

const SAMPLES = [
  { label: "募集登録入力サンプル1", value: text1 },
  { label: "募集登録入力サンプル2", value: text2 },
  { label: "募集登録入力サンプル3", value: text3 },
];

export default function RecruitmentRegistrationSampleSelection() {
  const [selectedText, setSelectedText] = useState(text1);

  return (
    <Box>
      <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap", mb: 2 }}>
        {SAMPLES.map(({ label, value }) => {
          const isSelected = selectedText === value;
          return (
            <Button
              key={label}
              onClick={() => setSelectedText(value)}
              disableRipple
              sx={{
                fontSize: "16px",
                color: "black",
                borderBottom: isSelected ? "2px solid black" : "2px solid transparent",
                minWidth: "200px",
                padding: "12px 20px",
                borderRadius: 0,
                background: "none",
                boxShadow: "none",
                "&:hover": {
                  background: "none",
                },
              }}
            >
              {label}
            </Button>
          );
        })}
      </Box>

      <Paper sx={{ p: "20px" }}>
        <NormalText text={selectedText} />
      </Paper>
    </Box>
  );
}